
/**
* No descargar documentos
* @param id accepts userMainAccountId, userId, stationId
* @returns returns a boolean
*/
export const permitDownload = (id: string) => {
  const stations = [
    // GROUP ENERSER
    "7Fd6iCYkmXtOYmim8QpV",
    "CNzLQ6ovgouJp1kTeLs8",
    "NWiRB0PnwV8ZwGdu8VxT",
    "ijMfxjJuqkxDrmzlEV6q",
    "nsUGtC9XMEMr3tKUOfG3",
    // END ENERSER
    "35EbjkTrSsNlXwZEXjLx",
    "4rpwYBMoevns5kZg5536",
    "BFBwT5TU0gFT3e0qS8r0",
    "FfLpZoM4V31QUo3yhPrf",
    "HA84yK58nyqJfEmjR7n7",
    "Iyi5Y4YcUXfHfhy3ugNn",
    "MAImtfATLY27OMdTcXwd",
    "UsoDHvQJTdQijPWteF2h",
    "WOTc7V5uLT3MtToJFtnl",
    "j7H2fP7rIjBnaHELIxzd",
    "kUaCUdQ2z3HxiBJBiZYC",
    // BLUE GAS S.A. DE C.V.
    "2AZl14u3rKv4Wk9mRSTc",
    "7iGQu97nr0InaRsTbVkm",
    "87B9OUK5VL0rHRwY5d2f",
    "B2DOLxvaXcM1Kl6aHM9y",
    "J5utF4WUb7Ri9hKNS53e",
    "SkJwrC8mPhUlTtwT80qQ",
    "ZrhCzuyG2SlW7Qe1d7WF",
    "ocXfCAIODWVcbXBUuEuw",
    "tF4zrRfLwakJg7F3edzu",
  ];

  const userMainAccount = [
    'VIiMcjpciPace5La8WMbSM1WJQv2',
    // BLUE GAS S.A. DE C.V.
    '4J35m5LIOZW9VCmlxcT2Vfz5czW2'
  ];

  const user = [
  ];

  if (userMainAccount.includes[id]) return false
  if (stations.includes[id]) return false
  if (user.includes[id]) return false
  return true;
}